// @flow
import React, {useEffect, useReducer} from 'react';
import SeeMore from './views/SeeMore';
import Thanks from './views/Thanks';
import ThanksNo from './views/ThanksNo';
import {reducer} from './reducer';
import {triggerPropertyHitPromptPresentedEvent} from '../../utils/collectionEdapUtils';

import './SeeMorePrompt.less';

type Props = {
    listingId: string,
    onDemote: Function
};

const SeeMorePrompt = ({listingId, onDemote}: Props) => {
    useEffect(() => {
        triggerPropertyHitPromptPresentedEvent(listingId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const initState = {
        CurrentView: SeeMore,
        views: {SeeMore, Thanks, ThanksNo}
    };
    const [state, dispatch] = useReducer(reducer, initState);
    const {CurrentView} = state;
    return (
        <div className="SeeMorePrompt">
            <CurrentView
                dispatch={dispatch}
                listingId={listingId}
                onDemote={onDemote}
            />
        </div>
    );
};

export default SeeMorePrompt;
